import React from 'react';
import { Dialog, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import ContentPlayer from './ContentPlayer';
import { useContentPlayer } from '../../context/ContentPlayerContext';

const FullScreenDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '100%',
    height: '100%',
    margin: 0,
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: 0,
    backgroundColor: '#000',
  },
}));

const ContentPlayerModal = ({ 
  open, 
  onClose, 
  courseId, 
  contentId,
  returnUrl
}) => { 
    const { modalState } = useContentPlayer();
    const currentContentId = modalState.currentContentId || contentId;
    
    return (
      <FullScreenDialog
        open={open}
        onClose={onClose}
        fullScreen      
      >
        <Box sx={{ width: '100%', height: '100%' }}>
        {open && contentId &&  ( //courseId can be null if not part of a course
          <ContentPlayer 
              courseId={courseId} 
              contentId={currentContentId} 
              isModal={true}
              onClose={onClose}
              returnUrl={returnUrl}
              isLearnerMode={modalState.isLearnerMode}
              onComplete={modalState.onComplete}
              isSearchResult={modalState.isSearchResult}
              byContentId={modalState.byContentId}
              singleContent={!courseId}
          /> 
          )}       
        </Box>
      </FullScreenDialog>
    );
};

export default ContentPlayerModal;